import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { TableFormatter } from '@/@diffrag/table/TableFormatter'
import { api } from '@/api'
import { StatusEnum4 } from '@/../codegen/__generated__/api_sdk'
import { useQueryParams } from '@/@diffrag/hooks/useQueryParams'
import { OffsetPagination } from '@/@diffrag/OffsetPagination'
import { useNavigate } from 'react-router-dom'
const STATUS_OPTIONS = [
  { label: '전체', value: undefined },
  { label: '대기', value: StatusEnum4.PENDING },
  {
    label: '컨택중',
    value: StatusEnum4.CONTACTING,
  },
  {
    label: '컨택완료',
    value: StatusEnum4.CONTACT_COMPLETED,
  },
  {
    label: '제휴완료',
    value: StatusEnum4.PARTNERSHIP_COMPLETED,
  },
  { label: '보류', value: StatusEnum4.ON_HOLD },
  { label: '종료', value: StatusEnum4.ENDED },
]

export default function Inquiry() {
  const page = useQueryValue('page', 1)
  const q = useQueryValue('q', undefined)
  const navigate = useNavigate()
  const { query } = useQueryParams<{
    status?: StatusEnum4
  }>({
    status: undefined,
  })

  const { data, refetch, isFetching } = useApi({
    id: 'userList',
    fn: api().adminBusinessInquiry.adminBusinessInquiryList,
    params: {
      limit: 20,
      page,
      q,
      status: query.status || undefined,
    },
  })

  const onDelete = async (id: number) => {
    await api().adminBusinessInquiry.adminBusinessInquiryDelete(id)
  }

  return (
    <ContentView>
      <SimpleTable
        options={{
          disableNew: true,
          disableSort: true,
        }}
        totalCount={data?.total}
        onDelete={async (rows) => {
          await Promise.all(rows.map((row) => onDelete(row.id)))
          refetch()
        }}
        onRowClick={(row) => {
          navigate(`/inquiry/edit?id=${row.id}`)
        }}
        filters={[
          {
            label:
              {
                전체: '전체',
                [StatusEnum4.PENDING]: '대기',
                [StatusEnum4.CONTACTING]: '컨택중',
                [StatusEnum4.CONTACT_COMPLETED]: '컨택완료',
                [StatusEnum4.PARTNERSHIP_COMPLETED]: '제휴완료',
                [StatusEnum4.ON_HOLD]: '보류',
                [StatusEnum4.ENDED]: '종료',
              }[query.status || '전체'] ?? '상태',
            key: 'status',
            items: [
              ...STATUS_OPTIONS.map((item) => ({
                label: item.label,
                value: item.value?.toString() || '',
              })),
            ],
          },
        ]}
        columns={[
          {
            label: 'NO',
            key: 'id',
            width: 100,
            isPrimary: true,
          },
          {
            label: '병원명',
            key: 'clinicName',
            isPrimary: true,
          },
          {
            label: '성함',
            key: 'name',
          },
          {
            label: '직함',
            key: 'position',
          },
          {
            label: '연락처',
            key: 'phoneNumber',
          },
          {
            label: '이메일',
            key: 'email',
          },
          {
            label: '문의날짜',
            key: 'createDate',
            formatter: TableFormatter.datetime(),
          },
          {
            label: '컨택날짜',
            key: 'contactDate',
            formatter: TableFormatter.datetime(),
          },
          {
            label: '상태',
            key: 'status',
            valueMap: {
              PENDING: '대기',
              CONTACTING: '컨택중',
              CONTACT_COMPLETED: '컨택완료',
              PARTNERSHIP_COMPLETED: '제휴완료',
              ON_HOLD: '보류',
              ENDED: '종료',
            },
          },
        ]}
        data={data?.items}
        isLoading={isFetching}
      />
      <OffsetPagination page={page} total={data?.total} pageSize={20} />
    </ContentView>
  )
}
